import {
  AbstractControl,  NG_ASYNC_VALIDATORS, AsyncValidator
} from '@angular/forms';
import { Directive, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedUrlRoutes, UtilHttpStatus } from '@formbird/shared';

@Directive({
  selector: '[scPasswordValidator]',
  providers: [
    {provide: NG_ASYNC_VALIDATORS, useExisting: PasswordValidatorDirective, multi: true}
  ]
})
export class PasswordValidatorDirective implements AsyncValidator {
  @Input('scPasswordValidator') validatorMsg: any;
  constructor(private httpClient: HttpClient,
              private domSanitizer: DomSanitizer) {
  }

  validate(control: AbstractControl) {
    const password = control.value;
    const param = {
      pass: password
    };
    const self = this;
    return new Promise((resolve, reject) => {
      self.httpClient.post(SharedUrlRoutes.serverRoutes.testPassword, param,
        {responseType: 'text'} ).subscribe(res => {
          let data;
          data = (res === 'OK' ? {} : JSON.parse(res));
          if (data.passwordFailures) {
            const failures = data.passwordFailures;
            let failMessage = 'Your password didn\'t pass the following criteria:';

            for (let i = 0; i < failures.length; i++) {
              const fail = failures[i];
              failMessage += '' + fail.failMsg + '';
            }

            failMessage += '';
            self.validatorMsg.passwordValidationErrMsg = failMessage;
            resolve(false);
          } else {
            self.validatorMsg.passwordValidationErrMsg = null;
            resolve(data.status === UtilHttpStatus.OK);
          }
        },
        error => {
          self.validatorMsg.passwordValidationErrMsg = 'Server returned an error while validating password.';
          resolve(false);
        });
    });

  }
}
